// extracted by mini-css-extract-plugin
module.exports = {"title":"Column_title__2uyY-"};